export enum AB_TESTS {
  EXAMPLE = 'abtest_example',
  QUESTS = 'abtest_le_quests',
}

export const AB_TESTS_PREFIX = 'abtest';
